<script lang="ts" setup>
import { Badge } from '@forgd/ui-kit/badge'

interface Step {
  step: string
  title: string
  body: string
}

const steps: Step[] = [
  {
    step: 'Step 1',
    title: 'Learn best practices',
    body: 'Analyze research data from 1500+ blockchain projects to construct your launch plan, or compare your performance.',
  },
  {
    step: 'Step 2',
    title: 'Leverage free self-service tools',
    body: 'Use Forgd to design tokenomics, engage market makers, plan your launch, and explore all our specialized tools at your disposal.',
  },
  {
    step: 'Step 3',
    title: 'Unlock extra features',
    body: 'Create an account and publish a whitepaper, onboard with market makers, and TGE with a Forgd account.',
  },
]
</script>

<template>
  <section data-el="HomeHowToStart" class="flex flex-col gap-8">
    <h3 class="text-sm leading-5.25 font-semibold text-primal">
      How to start with Forgd
    </h3>

    <div class="flex flex-col gap-8 md:flex-row md:gap-0">
      <div
        v-for="(item, i) in steps"
        :key="item.step"
        class="flex flex-1 flex-col gap-5"
        :class="[
          i > 0 ? 'md:border-l md:border-default md:pl-10' : '',
          i < steps.length - 1 ? 'md:pr-10' : '',
        ]"
      >
        <div class="flex flex-col items-start gap-2">
          <Badge variant="gray" class="border-0">
            {{ item.step }}
          </Badge>
          <h4 class="text-sm leading-5.25 font-semibold text-primal">
            {{ item.title }}
          </h4>
        </div>
        <p class="text-sm leading-5.25 text-secondary">
          {{ item.body }}
        </p>
      </div>
    </div>
  </section>
</template>
